export const isFileTypeInvalid =
  (fileFormatString: string, errorMessage: string) =>
  (files: FileList | null): string | undefined => {
    if (!files) return undefined
    const acceptedFormats = fileFormatString.split(',')
    const fileFormat = files.item(0)?.type ?? '-'
    return acceptedFormats.includes(fileFormat) ? undefined : errorMessage
  }

export const isFileSizeInvalid =
  (fileSizeLimitInKb: number, errorMessage: string) =>
  (files: FileList | null): string | undefined => {
    if (!files) return undefined
    return Array.from(files).some((file) => bytesToKiloBytes(file.size) > fileSizeLimitInKb) ? errorMessage : undefined
  }

export const isTotalUploadSizeInvalid = (
  files: File[],
  totalUploadSizeLimitInKb: number,
  errorMessage: string
): string | undefined => {
  if (!files) return undefined
  return bytesToKiloBytes(Array.from(files).reduce((sum, next) => sum + next.size, 0)) > totalUploadSizeLimitInKb
    ? errorMessage
    : undefined
}

const bytesToKiloBytes = (bytes: number): number => bytes / 1000
